import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { setupServiceWorker } from './pwa/registerSW.js'
import './styles.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('missing #root container')
}

setupServiceWorker()

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
